import { firestore } from "@/firebase";
//import firebase from "firebase/app";
//import "firebase/auth";

const state = {
  tests: [],
  allTests: [],
  benchmarks: null,
  statusTypes: {
    error: {
      color: "#880000",
      colorFaded: "#ffaaaa",
      title: "Error"
    },
    initialised: {
      color: "#aa4400",
      colorFaded: "#ffcc88",
      title: "Initialised"
    },
    received: {
      color: "#0044aa",
      colorFaded: "#88ccff",
      title: "Received"
    },
    processing: {
      color: "#0044aa",
      colorFaded: "#88ccff",
      title: "Processing"
    },
    completed: {
      color: "#00aa44",
      colorFaded: "#88ffcc",
      title: "Completed"
    }
  }
};

const getters = {
  tests: state => state.tests,
  allTests: state => state.allTests,
  benchmarks: state => state.benchmarks,
  benchmarkSingle: state => id => state.benchmarks[id]
};

const mutations = {
  SET_TESTS(state, tests) {
    state.tests = tests;
  },
  SET_ALLTESTS(state, tests) {
    state.allTests = tests;
  },
  SET_BENCHMARKS(state, benchmarks) {
    state.benchmarks = benchmarks;
  }
};

let testsSubscription;
let allTestsSubscription;

const actions = {
  subscribe({ commit, rootState }) {
    testsSubscription = firestore
      .collection("users")
      .doc(rootState.UserStore.user.uid)
      .collection("tests")
      .orderBy("created", "asc")
      .onSnapshot(querySnapshot => {
        const all = querySnapshot.docs
          .map(doc => {
            return { id: doc.id, ...doc.data() };
          })
          .sort((a, b) => b.created - a.created);
        commit("SET_TESTS", all);
      });
  },
  unsubscribe() {
    testsSubscription();
  },
  subscribeAll({ commit, rootState }, payload) {
    const { statusFilter } = payload;
    var query = firestore.collectionGroup("tests").orderBy("created", "asc");
    if (statusFilter) query = query.where("status", "==", statusFilter);

    allTestsSubscription = query.onSnapshot(querySnapshot => {
      const all = querySnapshot.docs
        .map(doc => {
          return { id: doc.id, ...doc.data() };
        })
        .sort((a, b) => b.created - a.created);
      commit("SET_ALLTESTS", all);
    });
  },
  unsubscribeAll() {
    allTestsSubscription();
  },
  async addToClient({ rootState, dispatch }, payload) {
    const { clientId, kit } = payload;
    const client = await dispatch("ClientsStore/get", clientId, { root: true });
    await firestore
      .collection("users")
      .doc(rootState.UserStore.user.uid)
      .collection("tests")
      .add({
        kit,
        status: "initialised",
        created: Date.now(),
        updated: Date.now(),
        billed: false,
        billedTime: null,
        clientId,
        client,
        userId: rootState.UserStore.user.uid,
        userName: rootState.UserStore.user.name,
        log: [
          {
            timestamp: Date.now(),
            type: "status",
            event: "initialised"
          }
        ]
      });
    await dispatch("ClientsStore/updated", { id: clientId }, { root: true });
  },
  async delete({ rootState, dispatch }, testId) {
    await firestore
      .collection("users")
      .doc(rootState.UserStore.user.uid)
      .collection("tests")
      .doc(testId)
      .delete();

    dispatch(
      "addToast",
      {
        message: "Deleted test!",
        type: "pending"
      },
      { root: true }
    );
  },
  async getByClient({ rootState }, clientId) {
    return await firestore
      .collection("users")
      .doc(rootState.UserStore.user.uid)
      .collection("tests")
      .where("clientId", "==", clientId)
      .get()
      .then(res => {
        return res.docs.map(doc => {
          return { id: doc.id, ...doc.data() };
        });
      });
  },
  async get({ rootState }, payload) {
    const doc = await firestore
      .collection("users")
      .doc(payload.userId ? payload.userId : rootState.UserStore.user.uid)
      .collection("tests")
      .doc(payload.testId)
      .get();
    return { id: doc.id, ...doc.data() };
  },
  async save({ rootState }, payload) {
    const { test, eventNote } = payload;
    const currentTest = await firestore
      .collection("users")
      .doc(test.userId)
      .collection("tests")
      .doc(test.id)
      .get();
    const currentTestData = currentTest.data();
    const timestamp = Date.now();
    if (!test.log) test.log = [];
    if (currentTestData.status !== test.status)
      test.log.push({
        timestamp,
        type: "status",
        event: test.status,
        note: eventNote
      });
    if (currentTestData.billed !== test.billed)
      test.log.push({
        timestamp,
        type: "billing",
        event: test.billed ? "billed" : "unbilled",
        note: eventNote
      });

    await firestore
      .collection("users")
      .doc(test.userId)
      .collection("tests")
      .doc(test.id)
      .update({ ...test, updated: timestamp });
  },
  async getBenchmarks({ commit }) {
    await firestore
      .collection("benchmarks")
      .get()
      .then(res => {
        let benchmarks = {};
        res.docs.forEach(doc => {
          benchmarks[doc.id] = doc.data();
        });
        commit("SET_BENCHMARKS", benchmarks);
      });
  },
  async getAll(context) {
    return await firestore
      .collectionGroup("tests")
      .get()
      .then(res => {
        return res.docs.map(doc => {
          return { id: doc.id, ...doc.data() };
        });
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
